"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUTS_NO_LABEL = exports.EXCLUDED_INPUTS = exports.INLINE_INPUTS = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_1 = __importDefault(require("@emotion/styled"));
const row_1 = __importDefault(require("./row"));
const label_1 = __importDefault(require("../label"));
const utils_1 = require("../../utils");
const use_form_1 = __importStar(require("../../form/use-form"));
const constants_1 = require("../../constants");
const inputs_1 = require("../inputs");
/**
 * <InlineInputRow /> corresponds with the "group" property in a field's config.
 * When fields are given a group they are rendered within this component,
 * where all fields with the same group value sit on the same row.
 */
exports.INLINE_INPUTS = {
    [constants_1.FIELD_TYPE_NAMES.SELECT]: inputs_1.SelectInput,
    [constants_1.FIELD_TYPE_NAMES.SIMPLE_SELECT]: inputs_1.SimpleSelectInput,
    [constants_1.FIELD_TYPE_NAMES.TYPEAHEAD]: inputs_1.TypeaheadInput,
    [constants_1.FIELD_TYPE_NAMES.STRING]: inputs_1.TextInput,
    [constants_1.FIELD_TYPE_NAMES.TEXTAREA]: inputs_1.TextareaInput,
    [constants_1.FIELD_TYPE_NAMES.RADIO]: inputs_1.RadioInput,
    [constants_1.FIELD_TYPE_NAMES.DOB]: inputs_1.DOBInput,
    [constants_1.FIELD_TYPE_NAMES.SSN]: inputs_1.SSNInput,
    [constants_1.FIELD_TYPE_NAMES.PARTIAL_SSN]: inputs_1.SSNInput,
    [constants_1.FIELD_TYPE_NAMES.DATE]: inputs_1.DateInput,
    [constants_1.FIELD_TYPE_NAMES.TIME]: inputs_1.TimeInput,
    [constants_1.FIELD_TYPE_NAMES.EMAIL]: inputs_1.EmailInput,
    [constants_1.FIELD_TYPE_NAMES.PHONE]: inputs_1.PhoneInput,
    [constants_1.FIELD_TYPE_NAMES.CHECKBOX]: inputs_1.CheckboxInput,
    [constants_1.FIELD_TYPE_NAMES.NAME]: inputs_1.NameInputRow,
    [constants_1.FIELD_TYPE_NAMES.MULTI_SELECT]: inputs_1.MultiSelectInput,
    [constants_1.FIELD_TYPE_NAMES.NPI]: inputs_1.NPIInput,
    [constants_1.FIELD_TYPE_NAMES.FILE]: inputs_1.FileInput
};
exports.EXCLUDED_INPUTS = [
    constants_1.FIELD_TYPE_NAMES.ADDRESS,
    constants_1.FIELD_TYPE_NAMES.ARRAY,
    constants_1.FIELD_TYPE_NAMES.INLINE,
    constants_1.FIELD_TYPE_NAMES.HIDDEN,
    constants_1.FIELD_TYPE_NAMES.AGE_GROUPS_SEEN
];
/**
 * Define a map of fields that should not be prepended
 * with an additional label. This is going to be for inputs
 * that already come with their own label
 */
exports.INPUTS_NO_LABEL = {
    [constants_1.FIELD_TYPE_NAMES.EMAIL]: true,
    [constants_1.FIELD_TYPE_NAMES.PHONE]: true,
    [constants_1.FIELD_TYPE_NAMES.CHECKBOX]: true,
    [constants_1.FIELD_TYPE_NAMES.NAME]: true
};
const InlineInputRowWrapper = styled_1.default.div `
  height: 100%;
`;
const InlineInputRowItem = ({ field }) => {
    const { type, label, path, isRequired } = field;
    const { context: { isRequiredMarker, isNotRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    const Field = exports.INLINE_INPUTS[type];
    return (react_1.default.createElement(InlineInputRowWrapper, null,
        !(type in exports.INPUTS_NO_LABEL) && (react_1.default.createElement(label_1.default, { isRequired: isRequired, isRequiredMarker: isRequiredMarker, id: path ? `${path}-label` : undefined, isNotRequiredMarker: isNotRequiredMarker }, label)),
        react_1.default.createElement(Field, { key: `input-row-${path}`, path: path })));
};
InlineInputRowItem.propTypes = {
    field: prop_types_1.default.shape({
        type: prop_types_1.default.string,
        label: prop_types_1.default.string,
        path: prop_types_1.default.string,
        isRequired: prop_types_1.default.bool
    })
};
/**
 * Renders a list of subFields within a single row.
 *
 * @param {Object} props
 * @param {String} props.path
 */
const InlineInputRow = ({ path, customInlineRows }) => {
    const [{ config: { subFields = {}, width } = {} }] = (0, use_form_1.default)(path);
    const orderedFields = (0, utils_1.orderFields)(Object.values(subFields)).filter((field) => field.type in exports.INLINE_INPUTS);
    return (react_1.default.createElement(row_1.default, { width: width, flexGrowSizes: orderedFields.map((field) => field.groupFlexGrow || 1) }, orderedFields.map((field) => {
        const CustomField = customInlineRows
            ? customInlineRows[field.type]
            : undefined;
        if (CustomField) {
            return (react_1.default.createElement(CustomField, { key: `inline-input-row-${field.label}-${field.path}`, path: field.path, label: field.label }));
        }
        return (react_1.default.createElement(InlineInputRowItem, { key: `inline-input-row-${field.label}-${field.path}`, field: field }));
    })));
};
InlineInputRow.propTypes = {
    path: prop_types_1.default.string,
    customInlineRows: prop_types_1.default.objectOf(prop_types_1.default.func)
};
exports.default = InlineInputRow;
//# sourceMappingURL=inline-input-row.js.map